import { Button, Modal } from "react-bootstrap";

export const ConfirmationModal: React.FC<any> = ({
  title,
  body,
  primaryText,
  secondaryText,
  show,
  handleClose,
  handlePrimary,
  handleSecondary,
}) => {
  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button onClick={handleSecondary} variant="secondary" size="sm">
          {secondaryText}
        </Button>
        <Button size="sm" variant="primary" onClick={handlePrimary}>
          {primaryText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
